module.controller('sampleLineCtrl', [ '$scope', '$rootScope', '$state', 'planSamplingService', 'dateUtilService', 'sampleDataResolve', sampleLineCtrlFn ]);
function sampleLineCtrlFn($scope, $rootScope, $state, planSamplingService, dateUtil, sampleData) {
	var vm = $scope;

	vm.idSample = $state.params.idSample;
	vm.idSampling = $state.params.idSampling;
	vm.idPlan = $state.params.idPlan;
	vm.sample = {};
	vm.sampleInfo = {};

	function init() {
		vm.sample = sampleData.getData().auditInfo;
		vm.sampleInfo = sampleData.getData().sample;
		vm.sample.forEach(sampleFormat);
		console.log(vm.sample);
	}

	function sampleFormat(s) {
		s.stateDate = dateUtil.formatMomentDateTime(s.stateDate);
		var event = getConstantById(SAMPLE_EVENT, s.event);
		s.icon = event.icon;
		s.className = event.className;
		s.showData = {};
		if (s.detail) {
			var detail = JSON.parse(s.detail);
			s.detail = {};
			if (detail.data && detail.data.length > 0 && detail.data[0].value) {
				for ( var idx in detail.data) {
					var item = detail.data[idx];
					s.detail[item.name] = JSON.parse(item.value);
				}

				if (s.event == SAMPLE_EVENT.CREATE.enumName || s.event == SAMPLE_EVENT.SCHEDULE.enumName) {
					s.detail.dto.scheduleDate = dateUtil.formatMomentDateTime(s.detail.dto.scheduleDate);
				}
			}
			s.showData.detail = s.detail;
		}
		if (s.additionalInfo) {
			s.additionalInfo = JSON.parse(s.additionalInfo);
			if (s.additionalInfo.data && Array.isArray(s.additionalInfo.data)) {
				for ( var idx in s.additionalInfo.data) {
					var item = s.additionalInfo.data[idx];
					try {
						s.additionalInfo[item.name] = JSON.parse(item.value);
					} catch (e) {
						s.additionalInfo[item.name] = item.value;
					}
				}
			}
			s.showData.additionalInfo = s.additionalInfo;
		}
	}

	init();

}